function ErrorMessage({ message }: { message: string }) {
  (window.flightLogger || console).error(message);
  return (
    <div className="text-black-tint-20 p2">
      <h1 className="h1">Error</h1>
      <div className="body ">{message}</div>
    </div>
  );
}

export { ErrorMessage };
